class Checked {
    inserted(el, binding, vnode) {
        if (binding.value) {
            el.checked = true;
        }
    }
}

export const checkedDirective = new Checked();



// WEBPACK FOOTER //
// ./src/directives/checked.js